export default __webpack_public_path__ + "static/media/regeneron.feaa275a.png";